import { collection, where, getDocs, query } from "firebase/firestore";
import { db } from "..";


const loginUser = async (password) => {
    const q = query(collection(db, "userInfo"), where("loginCode", "==", Number(password)))
    const querySnapshot = await getDocs(q);
    let user
    let _success
    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        user = {
            id: doc.id,
            ...doc.data()
        }
        // console.log(doc.data())
        // console.log(user)
        _success = 200
        return {user, success: _success}
    });
    if(_success === 200) {
        return {user, success: _success, loggedIn: true}
    }
    else {
        // success = 404
        return {success: 404, loggedIn: false}
    }
}

export default loginUser